import { useArticles } from "@faire/help-center-utils/hooks/article/useArticles";
import { useStrictLocalization } from "@faire/web/common/localization";
import { Application } from "@faire/web/slate/icons/foundation/Application";
import React from "react";
import { AddPaymentMethodIA } from "../instantAnswers/invoicesAndPayments-addPaymentMethod";
import { BulkDownloadIA } from "../instantAnswers/invoicesAndPayments-bulkDownload";
import { CanceledItemsIA } from "../instantAnswers/invoicesAndPayments-canceledItems";
import { ChangeDefaultPaymentMethodIA } from "../instantAnswers/invoicesAndPayments-changeDefaultPaymentMethod";
import { InvoiceBasicsIA } from "../instantAnswers/invoicesAndPayments-invoiceBasics";
import { ManageBillToAddressIA } from "../instantAnswers/invoicesAndPayments-manageBillToAddress";
import { Net60BasicsIA } from "../instantAnswers/invoicesAndPayments-net60Basics";
import { PaymentProcessingErrorIA } from "../instantAnswers/invoicesAndPayments-paymentProcessingError";
import { RefundsIA } from "../instantAnswers/invoicesAndPayments-refunds";
import { ReplacementItemsIA } from "../instantAnswers/invoicesAndPayments-replacementItems";
import { ReportDamagedMissingItemsOrShipmentsIA } from "../instantAnswers/invoicesAndPayments-reportDamagedMissingItemsOrShipments";
import { RequestCreditLimitIncreaseIA } from "../instantAnswers/invoicesAndPayments-requestCreditLimitIncrease";
import { ViewOrUpdatePaymentMethodsIA } from "../instantAnswers/invoicesAndPayments-viewOrUpdatePaymentMethods";
import { WhereToFindInvoicesL3IA } from "../instantAnswers/invoicesAndPayments-whereToFindInvoicesL3";
import { BillingAddressIA } from "../instantAnswers/shared-billingAddress";
export var useInvoicesAndPaymentsRetailerNodes = function useInvoicesAndPaymentsRetailerNodes() {
  var _articles$PaymentsAnd;
  var _useStrictLocalizatio = useStrictLocalization(),
    strictLocalize = _useStrictLocalizatio.strictLocalize;
  var articles = useArticles();
  return {
    InvoicesAndPayments: {
      id: "InvoicesAndPayments",
      label: strictLocalize({
        id: "LdQjJY",
        defaultMessage: [{
          "type": 0,
          "value": "Facturen en betalingen"
        }]
      }),
      icon: /*#__PURE__*/React.createElement(Application, {
        fontSize: "24px",
        color: "faireBlack"
      }),
      children: ["WhereToFindInvoices", "InvoiceBasics", "ManageBillToAddress", "DamagedOrMissingItemChanges", "NetTerms", "PaymentMethods", "PaymentProcessingError", "Refunds"],
      level: 1,
      sidebarTitle: strictLocalize({
        id: "6NNfgj",
        defaultMessage: [{
          "type": 0,
          "value": "Probleem met factuur of betaling"
        }]
      })
    },
    WhereToFindInvoices: {
      id: "WhereToFindInvoices",
      label: strictLocalize({
        id: "qzq0uy",
        defaultMessage: [{
          "type": 0,
          "value": "Waar vind je facturen"
        }]
      }),
      children: ["WhereToFindInvoicesL3", "BulkDownload"],
      level: 2
    },
    InvoiceBasics: {
      id: "InvoiceBasics",
      label: strictLocalize({
        id: "H2C1eS",
        defaultMessage: [{
          "type": 0,
          "value": "Basisprincipes van facturen"
        }]
      }),
      instantAnswer: InvoiceBasicsIA(strictLocalize),
      articles: [articles.PaymentsAndInvoices.UNDERSTANDING_ORDER_INVOICE],
      level: 2
    },
    ManageBillToAddress: {
      id: "ManageBillToAddress",
      label: strictLocalize({
        id: "ABfNwI",
        defaultMessage: [{
          "type": 0,
          "value": "Adres voor ‘Te factureren aan’ bewerken"
        }]
      }),
      instantAnswer: ManageBillToAddressIA(strictLocalize),
      articles: [articles.PaymentsAndInvoices.HOW_DO_I_CHANGE_MY_BILLING_ADDRESS],
      level: 2
    },
    DamagedOrMissingItemChanges: {
      id: "DamagedOrMissingItemChanges",
      label: strictLocalize({
        id: "Ub/Cf3",
        defaultMessage: [{
          "type": 0,
          "value": "Kosten voor beschadigde of ontbrekende artikelen"
        }]
      }),
      children: ["ReplacementItems", "CanceledItems", "ReportDamagedMissingItemsOrShipments"],
      level: 2
    },
    NetTerms: {
      id: "NetTerms",
      label: strictLocalize({
        id: "3TBjO1",
        defaultMessage: [{
          "type": 0,
          "value": "Netto betalingstermijn"
        }]
      }),
      children: ["Net60Basics", "RequestCreditLimitIncrease"],
      level: 2
    },
    PaymentMethods: {
      id: "PaymentMethods",
      label: strictLocalize({
        id: "9k5qQl",
        defaultMessage: [{
          "type": 0,
          "value": "Betaalmethoden"
        }]
      }),
      children: ["AddPaymentMethod", "ChangeDefaultPaymentMethod", "ViewOrUpdatePaymentMethods", "UpdateBillingAddress"],
      level: 2
    },
    PaymentProcessingError: {
      id: "PaymentProcessingError",
      label: strictLocalize({
        id: "P1j/2O",
        defaultMessage: [{
          "type": 0,
          "value": "Betalingsverwerkingsfout"
        }]
      }),
      instantAnswer: PaymentProcessingErrorIA(strictLocalize),
      level: 2
    },
    Refunds: {
      id: "Refunds",
      label: strictLocalize({
        id: "pXQSzm",
        defaultMessage: [{
          "type": 0,
          "value": "Terugbetalingen"
        }]
      }),
      instantAnswer: RefundsIA(strictLocalize),
      articles: [articles.ReturnsAndRefunds.MAKE_A_RETURN],
      level: 2
    },
    WhereToFindInvoicesL3: {
      id: "WhereToFindInvoicesL3",
      label: strictLocalize({
        id: "qzq0uy",
        defaultMessage: [{
          "type": 0,
          "value": "Waar vind je facturen"
        }]
      }),
      instantAnswer: WhereToFindInvoicesL3IA(strictLocalize),
      articles: [articles.PaymentsAndInvoices.UNDERSTANDING_ORDER_INVOICE],
      level: 3
    },
    BulkDownload: {
      id: "BulkDownload",
      label: strictLocalize({
        id: "ZQtKpJ",
        defaultMessage: [{
          "type": 0,
          "value": "Bulkdownload"
        }]
      }),
      instantAnswer: BulkDownloadIA(strictLocalize),
      articles: [articles.PaymentsAndInvoices.UNDERSTANDING_ORDER_INVOICE],
      level: 3
    },
    ReplacementItems: {
      id: "ReplacementItems",
      label: strictLocalize({
        id: "U+Ukho",
        defaultMessage: [{
          "type": 0,
          "value": "Vervangend(e) artikel(en)"
        }]
      }),
      instantAnswer: ReplacementItemsIA(strictLocalize),
      articles: [articles.MyOrders.REPORT_DAMAGED_MISSING],
      level: 3
    },
    CanceledItems: {
      id: "CanceledItems",
      label: strictLocalize({
        id: "NECB+a",
        defaultMessage: [{
          "type": 0,
          "value": "Geannuleerd(e) artikel(en)"
        }]
      }),
      instantAnswer: CanceledItemsIA(strictLocalize),
      articles: [articles.MyOrders.REPORT_DAMAGED_MISSING],
      level: 3
    },
    ReportDamagedMissingItemsOrShipments: {
      id: "ReportDamagedMissingItemsOrShipments",
      label: strictLocalize({
        id: "O+xW6s",
        defaultMessage: [{
          "type": 0,
          "value": "Beschadigd(e), ontbrekend(e) artikel(en) of zending(en) melden"
        }]
      }),
      instantAnswer: ReportDamagedMissingItemsOrShipmentsIA(strictLocalize),
      level: 3
    },
    Net60Basics: {
      id: "Net60Basics",
      label: strictLocalize({
        id: "KkMVQy",
        defaultMessage: [{
          "type": 0,
          "value": "Basisprincipes van Net60"
        }]
      }),
      instantAnswer: Net60BasicsIA(strictLocalize),
      articles: [articles.PaymentsAndInvoices.NET_60_TERMS],
      level: 3
    },
    RequestCreditLimitIncrease: {
      id: "RequestCreditLimitIncrease",
      label: strictLocalize({
        id: "0R+ccx",
        defaultMessage: [{
          "type": 0,
          "value": "Verhoging van kredietlimiet aanvragen"
        }]
      }),
      instantAnswer: RequestCreditLimitIncreaseIA(strictLocalize),
      articles: [(_articles$PaymentsAnd = articles.PaymentsAndInvoices.NET_60_TERMS) === null || _articles$PaymentsAnd === void 0 ? void 0 : _articles$PaymentsAnd.atSection("2")],
      level: 3
    },
    AddPaymentMethod: {
      id: "AddPaymentMethod",
      label: strictLocalize({
        id: "+EIson",
        defaultMessage: [{
          "type": 0,
          "value": "Betaalmethode toevoegen"
        }]
      }),
      instantAnswer: AddPaymentMethodIA(strictLocalize),
      articles: [articles.PaymentsAndInvoices.HOW_DO_I_PAY_FOR_ORDERS, articles.PaymentsAndInvoices.CHANGE_MY_PAYMENT_METHOD],
      level: 3
    },
    ChangeDefaultPaymentMethod: {
      id: "ChangeDefaultPaymentMethod",
      label: strictLocalize({
        id: "tEqTiy",
        defaultMessage: [{
          "type": 0,
          "value": "Standaardbetaalmethode wijzigen"
        }]
      }),
      instantAnswer: ChangeDefaultPaymentMethodIA(strictLocalize),
      articles: [articles.PaymentsAndInvoices.CHANGE_MY_PAYMENT_METHOD],
      level: 3
    },
    ViewOrUpdatePaymentMethods: {
      id: "ViewOrUpdatePaymentMethods",
      label: strictLocalize({
        id: "nBZmWg",
        defaultMessage: [{
          "type": 0,
          "value": "Betaalmethoden bekijken of bijwerken"
        }]
      }),
      instantAnswer: ViewOrUpdatePaymentMethodsIA(strictLocalize),
      articles: [articles.PaymentsAndInvoices.HOW_DO_I_PAY_FOR_ORDERS, articles.PaymentsAndInvoices.CHANGE_MY_PAYMENT_METHOD],
      level: 3
    },
    UpdateBillingAddress: {
      id: "UpdateBillingAddress",
      label: strictLocalize({
        id: "618M7s",
        defaultMessage: [{
          "type": 0,
          "value": "Factuuradres bijwerken"
        }]
      }),
      articles: [articles.PaymentsAndInvoices.HOW_DO_I_CHANGE_MY_BILLING_ADDRESS],
      instantAnswer: BillingAddressIA(strictLocalize),
      level: 3
    }
  };
};